/**
 * Returns the stack trace to this function call, minus the frame for this helper itself.
 * This only captures the CURRENT call site's frames, never a caught error's throw site —
 * when the triggering error is in hand, prefer getErrorStack().
 */
export function getStackTrace(): string {
  const lines = (new Error().stack ?? '').split('\n').map((line: string): string => line.trim());
  const framesToDrop = lines[0]?.startsWith('Error') ? 2 : 1;
  return lines.slice(framesToDrop).join('\n');
}

/**
 * Extracts a loggable stack (or best-effort description) from a caught value.
 * Unlike getStackTrace(), this preserves the original throw site carried by an Error.
 */
export function getErrorStack(error: unknown): string {
  if (error instanceof Error) {
    return error.stack ?? `${error.name}: ${error.message}`;
  }
  if (typeof error === 'string') {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}
